import React, { useCallback, useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { Alert, Box, Button, TextField, TextareaAutosize, Typography, setRef } from "@mui/material";
import { AcUnit, Check, ErrorOutline } from "@mui/icons-material";
import { AppSingleton } from "../services/user_config";
import { PlayerControllerComponent } from "../components/player-controller-component";
// import { AvatarMirrorPage } from "./avatar-mirror-page";
import { PoseDetectorComponent } from "../components/pose-detector-component";
// import { httpEndpoint } from "../services/backend";
import { data_list } from "../services/user_config";
import { getAdaptivFontSize, getRoute } from "../utils/CommonUtils";
import routes from "../basic/routes";
// import { Helmet } from "react-helmet";

// import Particles, { initParticlesEngine } from "@tsparticles/react";
// // import { loadAll } from "@/tsparticles/all"; // if you are going to use `loadAll`, install the "@tsparticles/all" package too.
// // import { loadFull } from "tsparticles"; // if you are going to use `loadFull`, install the "tsparticles" package too.
// import { loadSlim } from "@tsparticles/slim"; // if you are going to use `loadSlim`, install the "@tsparticles/slim" package too.
// // import { loadBasic } from "@tsparticles/basic"; // if you are going to use `loadBasic`, install the "@tsparticles/basic" package too.

// import { LightBubbleEffectComponent } from "../components/light-bubble-effect-component";
import { RibbonEffectComponent } from "../components/ribbon-effect-component";
import { GestureAlertComponent } from "../components/gesture-alert-component";
import { AvatarMirrorComponent } from "../components/avatar-mirror-component";
import { getOrientation } from "../utils/CommonUtils";

const IS_AVATAR = false;

const PoseMirror = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  // const [tfMemoryInfo, setTfMemoryInfo] = useState({});
  const appSingleton = new AppSingleton();
  const tutorialVideoRef = useRef(null);
  const gestureStatusRef = useRef({
    leftMissing: 0,
    leftLazy: 0,
    rightMissing: 0,
    rightLazy: 0,
  });
  const scoreRef = useRef({});
  const lastGestureReminderRef = useRef({
    status: null,
    lastDate: new Date(),
    message: "",
  });
  const isReadyRef = useRef(false);
  const [exerciseData, setExerciseData] = useState({});
  const [orientation, setOrientation] = useState(getOrientation()); // MARK: portrait, landscape

  const onScreenResize = () => {
    setOrientation(getOrientation());
  };

  useEffect(() => {
    const _exerciseDataList = data_list.filter((el) => el.exercise_id === id);
    if (_exerciseDataList.length > 0) {
      setExerciseData(_exerciseDataList[0]);
    }
    window.addEventListener("resize", onScreenResize);

    return () => {
      window.removeEventListener("resize", onScreenResize);
    };
  }, []);

  return (
    // <Box sx={{ backgroundColor: theme.palette.card.main }}>
    <Box
      sx={{ backgroundColor: exerciseData?.type?.includes("avatar") ? theme.palette.card.main : theme.palette.background.main }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 32,
          width: "100%",
          zIndex: 99,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <GestureAlertComponent
          gestureStatusRef={gestureStatusRef}
          lastGestureReminderRef={lastGestureReminderRef}
          isReadyRef={isReadyRef}
        />
      </Box>
      {/* <Helmet>
        <script src="https://cdn.jsdelivr.net/npm/@tsparticles/preset-firefly@3/tsparticles.preset.firefly.bundle.min.js" />
      </Helmet> */}
      <Box
        sx={{
          // position: "absolute",
          width: "100%",
          // height: "100vh",
          zIndex: -1,
          // backgroundSize: "cover",
          // backgroundPosition: "center",
        }}
      />
      <Box>
        {IS_AVATAR ? (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              width: window.innerWidth * 0.3,
              height: "auto",
              // height: window.innerHeight * 0.3,
              zIndex: 2,
              backgroundColor: "green",
            }}
            // hidden={ detector == null }
          >
            <AvatarMirrorComponent />
          </Box>
        ) : null}

        <PlayerControllerComponent
          tutorialVideoRef={tutorialVideoRef}
          gestureStatusRef={gestureStatusRef}
          scoreRef={scoreRef}
          exercise_id={id}
          title={exerciseData?.title ?? ""}
          subtitle={exerciseData?.subtitle ?? ""}
          trainer={exerciseData?.trainer ?? ""}
          videoUrl={`/video/${appSingleton.isDarkMode ? `${id}.mp4` : `${id}-white.mp4`}`}
          onComplete={({ score, accuracy }) => {
            // console.log(`score: ${score}\taccuracy: ${accuracy}`);
            const jsonString = JSON.stringify({ score, accuracy });
            // console.log(`jsonString: ${jsonString}`);
            const base64String = btoa(jsonString);
            const safeBase64String = encodeURIComponent(base64String);
            // console.log(`safeBase64String: ${safeBase64String}`);
            navigate(`${getRoute("result-page")}/${safeBase64String}`);
          }}
          isReadyRef={isReadyRef}
        />
        {appSingleton.isEffect ? <RibbonEffectComponent isReadyRef={isReadyRef} scoreRef={scoreRef} /> : null}
      </Box>

      <Box
        sx={{
          position: "fixed",
          // width: "100%",
          bottom: `${orientation === "landscape" ? 8 : 64}px`,
          left: "50%",
          transform: "translateX(-50%)",
          // left: 0,
          backgroundColor: "transparent",
          // height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        {/* <video
          ref={videoRef}
          // width={640 * 0.4}
          // height={480 * 0.4}
          autoPlay={true}
          playsInline={true}
          muted={true}
          style={{ display: "none" }}
        />
        <canvas ref={canvasRef} /> */}
        {IS_AVATAR ? null : (
          <PoseDetectorComponent
            gestureStatusRef={gestureStatusRef}
            scoreRef={scoreRef}
            tutorialVideoRef={tutorialVideoRef}
            isReadyRef={isReadyRef}
            exerciseId={id}
          />
        )}
      </Box>
    </Box>
  );
};

const f = () => {};

export { PoseMirror, f };
